const indexItems = [
  { id: 1, title: '动作冒险电影大全', count: '326部', desc: '涵盖好莱坞大片与国产动作佳作', icon: 'ri-sword-line' },
  { id: 2, title: '喜剧电影欢乐合集', count: '258部', desc: '轻松搞笑，适合全家一起看', icon: 'ri-emotion-laugh-line' },
  { id: 3, title: '悬疑推理烧脑专区', count: '192部', desc: '层层反转的高分悬疑力作', icon: 'ri-search-eye-line' },
  { id: 4, title: '爱情电影浪漫精选', count: '215部', desc: '从青春到永恒，感动每个瞬间', icon: 'ri-heart-line' },
  { id: 5, title: '科幻奇幻视觉盛宴', count: '178部', desc: '震撼特效与奇思妙想的碰撞', icon: 'ri-rocket-line' },
  { id: 6, title: '热播电视剧追更日历', count: '402部', desc: '每日更新，热门剧集追不停', icon: 'ri-tv-line' },
  { id: 7, title: '综艺节目精华全集', count: '289部', desc: '全网热门综艺爆笑名场面合集', icon: 'ri-live-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              影视专题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              按类型快速浏览天美麻花星空影视免费观看全部内容
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {indexItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 hover:bg-background-50 transition-all duration-300 cursor-pointer"
              >
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                  <i className={`${item.icon} text-lg text-primary-600`}></i>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mb-3">{item.desc}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-medium text-primary-600">{item.count}</span>
                  <span className="w-5 h-5 flex items-center justify-center text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-1 transition-all duration-300">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}